import { ChevronRight, Play } from 'lucide-react'

import type { WorkoutTemplate } from '@/api/types/workout'
import { Card } from '@/components/ui/card'
import { Spinner } from '@/components/ui/spinner'

import { trainedAgoLabel } from '../muscle-level'

type Props = {
  templates: WorkoutTemplate[]
  loading: boolean
  onStart: (template: WorkoutTemplate) => void
  onManage: () => void
}

/** テンプレートからセッションを始めるカード一覧 */
export const TemplateStartList = ({ templates, loading, onStart, onManage }: Props) => {
  if (loading) return <Spinner size={24} />

  if (templates.length === 0) {
    return (
      <Card className="cursor-pointer p-4 text-sm text-muted-foreground hover:bg-accent" onClick={onManage}>
        テンプレートがまだありません。タップして作成してください。
      </Card>
    )
  }

  return (
    <div className="grid grid-cols-1 gap-3">
      {templates.map((t) => {
        const ago = trainedAgoLabel(t.last_performed_at ?? null)
        return (
          <Card
            key={t.id}
            className="min-w-0 cursor-pointer gap-0 p-4 transition-colors hover:bg-accent active:bg-accent"
            onClick={() => onStart(t)}
          >
            <div className="flex items-center gap-3">
              <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-orange-500/15 text-orange-500">
                <Play className="size-5 fill-current" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-baseline justify-between gap-2">
                  <span className="truncate font-semibold">{t.name}</span>
                  <span className="shrink-0 text-xs text-muted-foreground">{ago ? `前回 ${ago}` : '未実施'}</span>
                </div>
                <div className="mt-0.5 truncate text-xs text-muted-foreground">
                  {t.items.length} 種目 ・ {t.items.map((i) => i.exercise_name).join(' / ')}
                </div>
              </div>
              <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
            </div>
          </Card>
        )
      })}
    </div>
  )
}
